import script from "./DashboardModuleSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardModuleSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardModuleSidebar.vue?vue&type=style&index=0&id=c321ce80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c321ce80"]])

export default __exports__